module.exports = __webpack_public_path__ + "static/media/MHRP09N0017.40440727.svg";